import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

export const getTaxVerificationRequirementName = (
  requirement: IRequirementResponse
) => requirement.name || "Taxpayer information";
